import type { ReactNode } from 'react'

export type AlertTone = 'ok' | 'warn' | 'err' | 'info'

const GLYPH: Record<AlertTone, string> = { ok: '✓', warn: '!', err: '×', info: 'i' }

export function Alert({
  tone,
  title,
  children,
  style,
}: {
  tone: AlertTone
  title?: ReactNode
  children?: ReactNode
  style?: React.CSSProperties
}) {
  return (
    <div className={`alert ${tone}`} style={style}>
      <span className="ai">{GLYPH[tone]}</span>
      <div>
        {title ? <b>{title}</b> : null}
        {children ? <p>{children}</p> : null}
      </div>
    </div>
  )
}

/** Banner for the screens whose endpoints are not built yet. */
export function ComingSoonBanner({ feature }: { feature: string }) {
  return (
    <Alert tone="info" title={`${feature} is coming soon`} style={{ marginBottom: 18 }}>
      The screen below is the finished design, but the {feature.toLowerCase()} endpoint is not live
      yet — submitting returns <span className="mono">501 NOT_IMPLEMENTED</span>. Nothing here will
      touch your QuickBooks data.
    </Alert>
  )
}
